/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Payments_Edit_DescriptionInputs */

const en_admin_payments_edit_description = /** @type {(inputs: Admin_Payments_Edit_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update order status and product information`)
};

/**
* | output |
* | --- |
* | "Update order status and product information" |
*
* @param {Admin_Payments_Edit_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_payments_edit_description = /** @type {((inputs?: Admin_Payments_Edit_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Payments_Edit_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_payments_edit_description(inputs)
});
export { admin_payments_edit_description as "admin.payments.edit_description" }